// HESOME GPT 챗봇 MVP - 개선된 챗베이스 스타일 UI + 기능 개선
import React, { useState, useEffect, useRef } from "react";
import HesomeLogo from "./assets/hesome-logo.jpg"; // 히썸 로고 경로에 맞게 수정

const FAQ_LIST = [
  "배송은 얼마나 걸리나요?",
  "반품은 어떻게 하나요?",
  "사이즈 추천 부탁드려요.",
];

const SYSTEM_PROMPT = {
  role: "system",
  content: `당신은 온라인 쇼핑몰 히썸(HESOME)의 고객 응대 챗봇입니다.
다음의 안내 사항을 참고하여 고객의 질문에 답변해 주세요.

---

결제 안내

- 무통장 입금의 경우 주문 시 기재해 주신 주문자명과 실제 입금자명이 정확히 일치해야 합니다. (띄어쓰기, 괄호 등 포함)

- 입금자명이 일치하지 않을 경우 게시판 혹은 고객센터로 문의 부탁드립니다.

- 고액 결제의 경우 안전을 위해 카드사에서 확인 전화를 드릴 수 있습니다.





배송 안내

- 오후 2시까지 결제/입금 확인이 되면 재고 보유 상품에 한하여 당일 출고됩니다.

- 금요일 오후 2시 이후 주문건부터는 차주 월요일에 일괄 배송됩니다.

- 배송이 장기적으로 지연될 시 개별적으로 안내해드립니다. (주말, 공휴일 제외)

- 지정 택배사는 우체국택배이며, 기본 배송비는 3,000원입니다.

  (7만원 이상 구매 시 무료 배송)

- 제주도 및 도서 산간 지역은 추가 운임료가 발생할 수 있습니다.

  (지금은 서비스 차원으로 저희 히썸에서 부담하고 있습니다)

- 택배사나 물류 사정, 자연재해 등의 사유로 배송이 지연될 수 있습니다.

- 고객 부주의(주소, 전화번호 오기재, 연락 두절 등)로 인해 반품되는 경우, 왕복 배송비는 고객님이 부담해주셔야 합니다.





교환&반품 안내

- 교환&반품은 상품 수령일로부터 7일 이내에 접수를 하시고 상품이 히썸으로 도착해야 합니다.

- 상품 하자 및 오배송으로 인한 교환&반품 배송비는 히썸에서 부담합니다.

- 단순 변심에 의한 교환&반품 배송비는 고객님께서 부담하셔야 합니다.  

반품 배송비 상세 안내 : 반품 상품을 제외한 최종 결제 금액이

                                7만원 미만일 시 : 6,000원 (구매 시 결제하셨던 배송비도 함께 환불됩니다.)

                                7만원 이상일 시 : 3,000원



- 배송비 입금 계좌 : 박현우(예금주) 국민 694701-01-482975

동명이인이 있을 수 있으니 입금자명 뒤에 연락처 뒷번호 네자리를 기재해 주시기 바랍니다.

- 현금 동봉 시 분실 우려가 있어 계좌 입금을 권장하며, 분실 시 당사에서는 책임지지 않습니다.

- 신용카드 결제 시 승인 취소 요청일로부터 2~7일, 실시간 계좌 이체는 2~5일 후 해당 은행, 카드사에서 환불 처리 됩니다.



- 교환&반품 주소 : 서울 중구 소공로 70 (충무로 1가) 서울중앙우체국 소포실 유경컴퍼니(히썸)

(사이트 통해 반품 신청하시면 저희 히썸에서 택배사 반품 접수 도와드리고 있습니다. 기사님 방문하시면 상품 전달 부탁드립니다)



교환&반품 불가 안내

- 상품 수령후 7일을 초과한 경우

- 상품의 택, 라벨을 제거하신 경우

- 고객의 부주의 또는 상품 사용으로 훼손되거나 그 외 서비스 등이 훼손되어 상품 가치가 떨어진 경우

- 착용 흔적, 오염, 손상이 확인된 경우 (세탁, 수선, 향수, 디퓨저 및 향취 등)

- 상품 특성상 워싱, 패턴(무늬)의 모양이나 위치가 약간씩 다른 경우

- 실밥, 올 등의 마감 처리가 가능한 수준으로 미흡한 경우

- 불량 상품이나 오배송 된 상품을 착용하여 오염, 훼손한 경우

- 촬영 조건, 해상도 및 개인 설정 등의 영향으로 고객님의 사용 기기에서 확인되는 색상과 실제 색상이 약간 차이 나는 경우





유의 사항

- 제품의 상세 사이즈는 측정 방법이나 위치에 따라 1~3cm 정도 오차가 있을 수 있습니다. 이는 불량 사유가 될 수 없습니다.

- 제품의 색상은 모니터 설정 및 환경에 따라 약간 차이가 있을 수 있습니다.




[고객센터]
- 070-8983-1727 / `
};

const Chatbot = () => {
  const [messages, setMessages] = useState([
    { role: "assistant", content: "안녕하세요! 무엇을 도와드릴까요?" },
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const callGPT = async (userInput) => {
    setLoading(true);
    const updatedMessages = [
      ...messages,
      { role: "user", content: userInput },
    ];
    setMessages(updatedMessages);


  console.log("✅ 불러온 API 키:", import.meta.env.VITE_OPENAI_API_KEY);



    const response = await fetch("https://api.openai.com/v1/chat/completions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${import.meta.env.VITE_OPENAI_API_KEY}`,
      },
      body: JSON.stringify({
        model: "gpt-4o",
        messages: [SYSTEM_PROMPT, ...updatedMessages],
      }),
    });

    const data = await response.json();
    const botReply = data.choices?.[0]?.message?.content || "답변을 불러오지 못했어요.";
    setMessages([...updatedMessages, { role: "assistant", content: botReply }]);
    setLoading(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    callGPT(input);
    setInput("");
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 text-sm">
      {isOpen ? (
        <div className="w-[380px] h-[600px] bg-white rounded-3xl shadow-2xl border border-gray-200 flex flex-col overflow-hidden">
          <div className="bg-gradient-to-r from-gray-100 to-gray-200 text-black px-4 py-3 text-md font-semibold flex items-center justify-between">
            <span>🛍️ HESOME 고객상담 챗봇</span>
            <button onClick={() => setIsOpen(false)} className="text-black text-xl font-bold">×</button>
          </div>

          <div className="px-4 pt-2 pb-1 bg-white border-b border-gray-100 flex gap-2 overflow-x-auto">
            {FAQ_LIST.map((q, idx) => (
              <button
                key={idx}
                onClick={() => callGPT(q)}
                className="bg-gray-100 border border-gray-300 rounded-full px-3 py-1 text-xs hover:bg-gray-200"
              >
                {q}
              </button>
            ))}
          </div>

          <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3 bg-white">
            {messages.map((m, i) => (
              <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"} items-end`}>
                {m.role === "assistant" && <img src={HesomeLogo} alt="bot" className="w-7 h-7 mr-2 rounded-full" />}
                <div
                  className={`px-4 py-3 rounded-2xl text-sm max-w-[70%] shadow-md whitespace-pre-wrap leading-relaxed ${
                    m.role === "user"
                      ? "bg-gray-500 text-white rounded-br-none"
                      : "bg-gray-100 text-gray-800 rounded-bl-none"
                  }`}
                >
                  {m.content}
                </div>
              </div>
            ))}
            {loading && (
              <div className="flex justify-start">
                <div className="px-4 py-2 rounded-2xl text-sm bg-gray-200 text-gray-600 shadow-md animate-pulse w-24">
                  ...답변 중
                </div>
              </div>
            )}
            <div ref={bottomRef} />
          </div>

          <form onSubmit={handleSubmit} className="border-t border-gray-200 bg-white px-4 py-3 flex gap-2">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="flex-grow border border-gray-300 px-4 py-2 rounded-full shadow-sm focus:outline-none focus:ring-2 focus:ring-gray-400"
              placeholder="궁금한 점을 입력해 주세요."
            />
            <button
              type="submit"
              className="bg-gray-300 text-black px-6 py-2 rounded-full hover:bg-gray-400 transition"
            >
              전송
            </button>
          </form>
        </div>
      ) : (
        <button
          onClick={() => setIsOpen(true)}
          className="bg-gray-400 hover:bg-gray-500 text-white px-5 py-3 rounded-full shadow-lg"
        >
          💬 챗봇 상담하기
        </button>
      )}
    </div>
  );
};

export default Chatbot;


